import { Members, MembershipRequests, MatterTab } from '@/components/matter';
import { useCurrentMatter } from '@/components/contexts/CurrentMatterContext';
import useMatterMembers from '@/hooks/useMatterMembers';
import { TooltipProvider } from "@/components/ui/tooltip";
import { useShellHeader, useShellHeaderBelow } from '@/components/contexts/ShellHeaderContext';
import { useMemo } from 'react';

const MatterMembers = () => {
  const { matter, canAccess } = useCurrentMatter();
  const { mutateMatterMembers } = useMatterMembers(
    matter.guid
  );
  useShellHeader({
    header: matter.name,
  });
  useShellHeaderBelow(
    useMemo(
      () => (matter ? <MatterTab activeTab="members" matter={matter} /> : null),
      [matter],
    ),
  );

  // Check if user is an owner
  const isOwner = canAccess('team', ['update']);

  return (
    <TooltipProvider>
      <div className="px-6 pt-6 pb-4 space-y-6">
        <Members matter={matter} />
        {isOwner && <MembershipRequests
          matter={matter}
          onRequestProcessed={() => mutateMatterMembers()}
        />}
      </div>
    </TooltipProvider>
  );
};
export default MatterMembers;
